module.exports = __webpack_public_path__ + "img/8_fineTeam_kf.edf94d02.png";